// extracted by mini-css-extract-plugin
export default {"btn":"index_btn__dC5ig","text":"index_text__T0T3S","error":"index_error__wMVcy"};